import { useState, useEffect } from 'react'
import { Scrollama, Step } from 'react-scrollama'
import Stage from './Stage'

const ScrollyTwo = ({ section, clicked }) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(-1)
  const [direction, setDirection] = useState(null)
  const [fade, setFade] = useState(false)

  const sectionNum = 2
  useEffect(() => {
    if (section <= sectionNum || !section) {
      setFade(false)
    } else setFade(true)
    if (section === sectionNum) setCurrentStepIndex(0)
    else setCurrentStepIndex(-1)
  }, [section, clicked])

  // This callback fires when a Step hits the offset threshold. It receives the
  // data prop of the step, which in this demo stores the index of the step.
  const onStepEnter = ({ data, direction }) => {
    setCurrentStepIndex(data)
    setDirection(direction)
    setFade(false)
  }

  const onStepExit = ({ data, direction }) => {
    if (data === 0 && direction === 'up') setCurrentStepIndex(-1)
    if (data === 2 && direction === 'down') setFade(true)
  }

  const opportunityContent = [
    'A dynamic economy doesn’t just create more jobs, it creates more opportunities for marginalized workers to get a step on the career ladder.',
    'For instance, when labor market churn is low, competition for each job opening is more intense and there is less mobility overall. Those in the weakest positions remain on the sidelines.',
    'However, in a more dynamic economy, higher rates of churn free up employment opportunities for those traditionally sidelined workers. It provides its own form of an economic safety net, too, catching displaced workers and pulling them into new occupations and endeavors.'
  ]

  return (
    <>
      <div className="scrolly-container">
        <Stage
          currentStepIndex={currentStepIndex}
          direction={direction}
          chart={'opportunity'}
          fade={fade}
        />
        <div className="scroller">
          <Scrollama
            onStepEnter={onStepEnter}
            onStepExit={onStepExit}
            offset={0.8}
            //debug
          >
            {opportunityContent.map((item, stepIndex) => (
              <Step data={stepIndex} key={stepIndex}>
                <div className={`step-container ${stepIndex === 2 && 'last'}`}>
                  <div className={`step-content step-${currentStepIndex}`}>
                    {item}
                  </div>
                </div>
              </Step>
            ))}
          </Scrollama>
        </div>
      </div>
    </>
  )
}

export default ScrollyTwo
